import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import VueGtm from "vue-gtm";
import store from "./store";
import Repository from "@/utils/Repository";
import vuetify from "./plugins/vuetify";
import axiosInterceptors from "./plugins/axiosInterceptors";
import gtmPlugin from "./plugins/gtmPlugin";
import "./plugins/nestedScopedSlots";
import "./plugins/i18n";
import "./plugins/colorTextWrapper";

Vue.use(axiosInterceptors, {
  axiosInstance: Repository,
  store
});

Vue.use(VueGtm, {
  id: "GTM-MBJ9D2C",
  debug: false, // Whether or not display console logs debugs
  loadScript: true, // Whether or not to load the GTM Script
  vueRouter: router
});

gtmPlugin(store);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount("#app");
